
































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import { firebaseAuth } from '../../server/init';
import usersDB from '../../server/init';
import slugify from 'slugify';

@Component({
  components: {},
})

export default class Signup extends Vue {
  private email: string | null = null;
  private password: string | null = null;
  private username: string | null = null;
  private usernameError: string | null = null;
  private emailError: string | null = null;
  private passwordError: string | null = null;
  private slugUser: string | null = null;

  private validateForm() {
    if (!this.email) {
      this.emailError = 'Please enter a valid email.';
    } else {
      this.emailError = null;
    }
    if (!this.username) {
      this.usernameError = 'Please enter a username.';
    } else {
      this.usernameError = null;
    }
    if (!this.password || this.password.length < 6) {
      this.passwordError = 'Please enter a password that is at least 6 characters.';
    } else {
      this.passwordError = null;
    }
    return true;
  }

  private signup() {
   this.validateForm();
   if (this.username && this.password && this.email) {
     this.slugUser = slugify(this.username, {
     replacement: '-',
     remove: /[$*_+~.()'"!\-:@#]/g,
     lower: true,
    });
     const ref = usersDB.collection('users').doc(this.slugUser);
     ref.get().then((doc) => {
      if (doc.exists) {
        this.usernameError = 'Sorry this username is already taken. Please choose a different username.';
      } else {
        firebaseAuth.createUserWithEmailAndPassword(this.email, this.password)
        .then((cred) => {
          ref.set({
            username: this.username,
            email: this.email,
            user_id: cred.user.uid,
          })
          .then(() => {
            this.$router.push('/');
          });
        })
        .catch((err) => {
          this.emailError = err.message;
        });
      }
    });
   }

  }
}
